import { Box } from '@chakra-ui/react';
import React from 'react';
import { Outlet } from 'react-router-dom';

const Notification: React.FC<unknown> = () => {
  return (
    <Box mx={{ base: 0, sm: 4, md: 6 }} my={{ base: 4, md: 6 }} minHeight="100%" p="4" bg="white" borderRadius="lg">
      <Outlet />
    </Box>
  );
};

export default Notification;
